<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <span>
          Small control with no value
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallEmpty" fieldTextContentTooltip />
            <button
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small control with pre-selected value
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallValue" fieldTextContentTooltip />
            <button
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small control disabled
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small control disabled with pre-selected value
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small control with error
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Small control with two errors
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="smallError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 3 -->

        <span>
          Small control with no value + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallEmpty" fieldTextContentTooltip />
            <button
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control with pre-selected value + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallValue" fieldTextContentTooltip />
            <button
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control disabled + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control disabled with pre-selected value + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control with error + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Small control with two errors + description
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="smallError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 4 -->

        <span>
          Small frameless control with no value
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallEmpty" fieldTextContentTooltip />
            <button
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with pre-selected value
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallValue" fieldTextContentTooltip />
            <button
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled with pre-selected value
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with error
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with two errors
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="smallError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 5 -->

        <span>
          Small frameless control with no value + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallEmpty" fieldTextContentTooltip />
            <button
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with pre-selected value + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallValue" fieldTextContentTooltip />
            <button
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled with pre-selected value + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="smallValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="smallValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with error + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with two errors + description
          <mat-form-field mat-input-height-small mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallError" fieldTextContentTooltip />
            <button
              *ngIf="smallError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="smallError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="smallError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <span>
          Small control with no value + suffix
          <mat-form-field mat-input-height-small>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="smallEmpty" fieldTextContentTooltip />
            <span matSuffix mat-suffix-outside>%</span>
            <button
              *ngIf="smallEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(smallEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>
      </div>
    </vi-panel>

    <vi-panel main>
      <div class="content" content>
        <!-- ROW 1 -->

        <span>
          Medium control with no value
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumEmpty" fieldTextContentTooltip />
            <button
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium control with pre-selected value
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumValue" fieldTextContentTooltip />
            <button
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="mediumEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled with pre-selected value
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="mediumValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium control with error
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" fieldTextContentTooltip />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Medium control with two errors
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" fieldTextContentTooltip />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="mediumError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 3 -->

        <span>
          Medium control with no value + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumEmpty" fieldTextContentTooltip />
            <button
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control with pre-selected value + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumValue" fieldTextContentTooltip />
            <button
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="mediumEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled with pre-selected value + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="mediumValue"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control with error + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" fieldTextContentTooltip />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Medium control with two errors + description
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" fieldTextContentTooltip />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="mediumError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 4 -->

        <span>
          Medium frameless control with no value
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumEmpty" fieldTextContentTooltip />
            <button
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with pre-selected value
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumValue" fieldTextContentTooltip />
            <button
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input
              #input
              matInput
              [readonly]="true"
              [formControl]="mediumEmpty"
              fieldTextContentTooltip
            />
            <button
              [disabled]="true"
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled with pre-selected value
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="mediumValue" />
            <button
              [disabled]="true"
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with error
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with two errors
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="mediumError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 5 -->

        <span>
          Medium frameless control with no value + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumEmpty" />
            <button
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with pre-selected value + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumValue" />
            <button
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="mediumEmpty" />
            <button
              [disabled]="true"
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled with pre-selected value + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="mediumValue" />
            <button
              [disabled]="true"
              *ngIf="mediumValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with error + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with two errors + description
          <mat-form-field mat-input-height-medium mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumError" />
            <button
              *ngIf="mediumError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="mediumError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="mediumError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <span>
          mat control with no value + suffix
          <mat-form-field mat-input-height-medium>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="mediumEmpty" />
            <span matSuffix mat-suffix-outside>%</span>
            <button
              *ngIf="mediumEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(mediumEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>
      </div>
    </vi-panel>

    <vi-panel main>
      <div class="content" content>
        <span>
          Large control with no value
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control disabled
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control with error
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with two errors
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 3 -->

        <span>
          Large control with no value + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with error + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with two errors + description
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 4 -->

        <span>
          Large frameless control with no value
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled with pre-selected value
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two errors
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 5 -->

        <span>
          Large frameless control with no value + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled with pre-selected value + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two errors + description
          <mat-form-field mat-input-height-large mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with no value + suffix
          <mat-form-field mat-input-height-large>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <span matSuffix mat-suffix-outside>%</span>
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>
      </div>
    </vi-panel>

    <vi-panel main>
      <div class="content" content>
        <span>
          Large control with no value
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control disabled
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large control with error
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with two errors
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 3 -->

        <span>
          Large control with no value + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with error + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with two errors + description
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 4 -->

        <span>
          Large frameless control with no value
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled with pre-selected value
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two errors
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <!-- ROW 5 -->

        <span>
          Large frameless control with no value + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeValue" />
            <button
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeEmpty" />
            <button
              [disabled]="true"
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled with pre-selected value + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [readonly]="true" [formControl]="largeValue" />
            <button
              [disabled]="true"
              *ngIf="largeValue.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeValue)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two errors + description
          <mat-form-field mat-input-height-large-label mat-input-frameless>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeError" />
            <button
              *ngIf="largeError.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeError)"
            >
              <mat-icon>close</mat-icon>
            </button>
            <span mat-input-description>Description</span>
            <mat-error *ngIf="largeError.hasError('pattern')">Incorrect value</mat-error>
            <mat-error *ngIf="largeError.hasError('pattern')">Invalid simulator</mat-error>
          </mat-form-field>
        </span>

        <span>
          Large control with no value + suffix
          <mat-form-field mat-input-height-large-label>
            <mat-label>Select Simulator</mat-label>
            <input #input matInput [formControl]="largeEmpty" />
            <span matSuffix mat-suffix-outside>%</span>
            <button
              *ngIf="largeEmpty.value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clear(largeEmpty)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
